import { AccountList } from 'pages/accounts';
import { ActivityHistory } from 'pages/activity-history';
import { CategoryCreate, CategoryEdit, CategoryList } from 'pages/categories';
import { ClientCreate, ClientEdit, ClientList, ClientShow } from 'pages/clients';
import { CreateCompanyConfig } from 'pages/company-config';
import { DamageCreate, DamageEdit, DamageList, DamageShow } from 'pages/damages';
import { DashboardPage } from 'pages/dashboard';
import { ExpenseList } from 'pages/expenses';
import { FinalStockOutList } from 'pages/final-stock-outs';
import { InventoryList, InventoryShow } from 'pages/inventories';
import { KitchenOrderList } from 'pages/kitchen';
import {
  MeasurementUnitCreate,
  MeasurementUnitEdit,
  MeasurementUnitList,
} from 'pages/measurement-units';
import { Pos } from 'pages/pos';
import { MakeProduct, MakeProductEdit, MakeProductList, MakeProductShow } from 'pages/product-make';
import { ProductCreate, ProductEdit, ProductList, ProductShow } from 'pages/products';
import {
  PurchaseStockCorrectionCreate,
  PurchaseStockCorrectionShow,
  PurchaseStockCorrectionsList,
} from 'pages/stock-correction-purchases';
import { PurchaseCreate, PurchaseList, PurchaseShow } from 'pages/purchases';
import { ReportsList } from 'pages/reports';
import { PosPaymentChannelsList } from 'pages/pos-payment-channels';
import { RestaurantPos } from 'pages/restaurant-pos';
import { RestaurantSalesList } from 'pages/restaurant-sales';
import { ReturnCreate, ReturnList, ReturnShow } from 'pages/returns';
import { RoleCreate, RoleEdit, RoleList, RoleShow } from 'pages/roles';
import { SaleCreate, SaleEdit, SaleList, SaleShow } from 'pages/sales';
import {
  SalesStockCorrectionCreate,
  SalesStockCorrectionShow,
  SalesStockCorrectionsList,
} from 'pages/stock-correction-sales';
import { StaffList } from 'pages/staff/list';
import { TransferStockCreate, TransferStockList, TransferStockShow } from 'pages/stock-transfers';
import { SupplierCreate, SupplierEdit, SupplierList, SupplierShow } from 'pages/suppliers';
import { TagCreate, TagEdit, TagList } from 'pages/tags';
import { TemplateCreate, TemplateEdit, TemplateList, TemplateShow } from 'pages/templates';
import { UserCreate, UserEdit, UserList, UserShow } from 'pages/users';
// import { VariantEdit, VariantList } from 'pages/variants';
import { WarehouseCreate, WarehouseEdit, WarehouseList, WarehouseShow } from 'pages/warehouses';
import { AiOutlineHistory } from 'react-icons/ai';
import { finalStockOutFeatureFlag } from 'utilities/final-stock-out';
import {
  RiApps2Line,
  RiArchiveFill,
  RiBarcodeBoxLine,
  RiBuilding3Line,
  RiCalculatorFill,
  RiDashboardLine,
  RiDeleteBin2Line,
  RiExchangeLine,
  RiFileChartLine,
  RiHashtag,
  RiHomeSmileLine,
  RiKnifeLine,
  RiLayout2Line,
  RiParentLine,
  // RiProductHuntLine,
  RiRefundLine,
  RiRestaurantLine,
  RiSettings4Line,
  RiShoppingBag2Line,
  RiStore3Fill,
  RiTeamFill,
  RiTodoLine,
  RiUser2Line,
  RiUserHeartLine,
  RiUserSettingsLine,
  RiWallet3Line,
} from 'react-icons/ri';

export const useResources = () => {
  const groupArray: { [key: string]: string[] } = {
    INSIGHTS: ['dashboard', 'reports', 'pos-payment-channels', 'activity-history', 'accounts'],
    TRANSACTION: [
      'sales',
      'stock-correction-sales',
      'restaurant-sales',
      'kitchen',
      'staff',
      'purchases',
      'stock-correction-purchases',
      'stock-transfers',
      'returns',
      'final-stock-outs',
      'damages',
    ],
    ITEMS: [
      'products',
      'product-make',
      'measurement-units',
      // 'variants',
      'inventories',
      'tags',
      'categories',
      'templates',
    ],
    CRM: ['clients', 'suppliers'],
    ADMINISTRATION: ['expenses', 'roles', 'users', 'warehouses', 'settings'],
    'POINT OF SALE': ['restaurant-pos', 'pos'],
  };

  const resources = [
    {
      name: 'dashboard',
      list: DashboardPage,
      icon: <RiDashboardLine />,
    },
    {
      name: 'reports',
      list: ReportsList,
      icon: <RiFileChartLine />,
    },
    {
      name: 'pos-payment-channels',
      list: PosPaymentChannelsList,
      icon: <RiFileChartLine />,
      options: {
        label: 'POS Payment Channels',
      },
    },
    {
      name: 'sales',
      list: SaleList,
      show: SaleShow,
      create: SaleCreate,
      edit: SaleEdit,
      icon: <RiStore3Fill />,
    },
    {
      name: 'stock-correction-sales',
      list: SalesStockCorrectionsList,
      create: SalesStockCorrectionCreate,
      show: SalesStockCorrectionShow,
      icon: <RiStore3Fill />,
      options: {
        label: 'Sales Stock Corrections',
      },
    },
    {
      name: 'restaurant-sales',
      list: RestaurantSalesList,
      icon: <RiRestaurantLine />,
    },
    {
      name: 'purchases',
      list: PurchaseList,
      show: PurchaseShow,
      create: PurchaseCreate,
      icon: <RiShoppingBag2Line />,
      options: {
        label: 'Purchase',
      },
    },
    {
      name: 'stock-correction-purchases',
      list: PurchaseStockCorrectionsList,
      create: PurchaseStockCorrectionCreate,
      show: PurchaseStockCorrectionShow,
      icon: <RiExchangeLine />,
      options: {
        label: 'Purchase Stock Corrections',
      },
    },
    {
      name: 'products',
      list: ProductList,
      show: ProductShow,
      create: ProductCreate,
      edit: ProductEdit,
      icon: <RiArchiveFill />,
      options: {
        label: 'Product',
      },
    },
    {
      name: 'measurement-units',
      list: MeasurementUnitList,
      create: MeasurementUnitCreate,
      edit: MeasurementUnitEdit,
      icon: <RiArchiveFill />,
      // options: {
      //   label: 'Product',
      // },
    },
    {
      name: 'templates',
      // parentName: 'products',
      list: TemplateList,
      create: TemplateCreate,
      edit: TemplateEdit,
      show: TemplateShow,
      icon: <RiLayout2Line />,
      options: {
        route: 'templates',
        // hide: false,
      },
    },
    // {
    //   name: 'variants',
    //   list: VariantList,
    //   edit: VariantEdit,
    //   options: {
    //     label: 'Variant',
    //   },
    //   icon: <RiProductHuntLine />,
    // },
    {
      name: 'inventories',
      list: InventoryList,
      show: InventoryShow,
      icon: <RiTodoLine />,
      options: {
        label: 'Inventory',
      },
    },
    {
      name: 'clients',
      list: ClientList,
      show: ClientShow,
      create: ClientCreate,
      edit: ClientEdit,
      icon: <RiTeamFill />,
    },
    {
      name: 'suppliers',
      list: SupplierList,
      show: SupplierShow,
      create: SupplierCreate,
      edit: SupplierEdit,
      icon: <RiParentLine />,
    },
    {
      name: 'warehouses',
      list: WarehouseList,
      show: WarehouseShow,
      create: WarehouseCreate,
      edit: WarehouseEdit,
      icon: <RiHomeSmileLine />,
      options: {
        label: 'Warehouses',
      },
    },
    {
      name: 'stock-transfers',
      list: TransferStockList,
      create: TransferStockCreate,
      show: TransferStockShow,
      icon: <RiExchangeLine />,
      options: {
        label: 'Stock Transfer',
      },
    },
    {
      name: 'damages',
      list: DamageList,
      show: DamageShow,
      create: DamageCreate,
      edit: DamageEdit,
      icon: <RiDeleteBin2Line />,
      options: {
        label: 'Damage Goods',
      },
    },
    {
      // Stitches S6: shown only when the tenant has stock.finalStockOut and the user may view it.
      name: 'final-stock-outs',
      list: FinalStockOutList,
      icon: <RiArchiveFill />,
      options: {
        label: 'Final Stock Out',
        featureFlag: finalStockOutFeatureFlag,
      },
    },
    {
      name: 'activity-history',
      list: ActivityHistory,
      icon: <AiOutlineHistory />,
      options: {
        label: 'Activity History',
      },
    },
    {
      name: 'users',
      list: UserList,
      show: UserShow,
      create: UserCreate,
      edit: UserEdit,
      icon: <RiUserSettingsLine />,
    },
    {
      name: 'tags',
      list: TagList,
      create: TagCreate,
      edit: TagEdit,
      icon: <RiHashtag />,
    },
    {
      name: 'categories',
      list: CategoryList,
      create: CategoryCreate,
      edit: CategoryEdit,
      icon: <RiApps2Line />,
    },
    {
      name: 'accounts',
      list: AccountList,
      icon: <RiCalculatorFill />,
    },
    {
      name: 'returns',
      list: ReturnList,
      show: ReturnShow,
      create: ReturnCreate,
      icon: <RiRefundLine />,
    },
    {
      name: 'expenses',
      list: ExpenseList,
      icon: <RiWallet3Line />,
    },
    {
      name: 'roles',
      list: RoleList,
      show: RoleShow,
      create: RoleCreate,
      edit: RoleEdit,
      icon: <RiUser2Line />,
    },
    {
      name: 'pos',
      list: Pos,
      icon: <RiBarcodeBoxLine />,
    },
    {
      name: 'restaurant-pos',
      list: RestaurantPos,
      icon: <RiBarcodeBoxLine />,
      options: {
        // hide: true,
      },
    },
    {
      name: 'settings',
      list: CreateCompanyConfig,
      icon: <RiSettings4Line />,
    },
    {
      name: 'product-make',
      list: MakeProductList,
      show: MakeProductShow,
      create: MakeProduct,
      edit: MakeProductEdit,
      icon: <RiBuilding3Line />,
      options: {
        label: 'Make',
      },
    },
    {
      name: 'kitchen',
      list: KitchenOrderList,
      icon: <RiKnifeLine />,
      options: {
        label: 'kitchen',
      },
    },
    {
      name: 'staff',
      list: StaffList,
      icon: <RiUserHeartLine />,
      options: {
        label: 'staff',
      },
    },
  ];

  return {
    resources,
    groupArray,
  };
};
